import { SIZE_FULL } from '@/lib/gridElements/size';

import { MentionMediasWidget } from '@/components/pages/listening/widget/MentionMediasWidget';

export const lastMentionedPosts = {
    title: 'chart.instagram.widget_last_mentioned_posts',
    id: 'widget_last_mentioned_posts',
    sortFields: ['created'],
    size: SIZE_FULL,
    type: 'widget',
    element: MentionMediasWidget
};
